import { Navigate, Outlet } from 'react-router-dom';
import { useBackendAuth } from '../hooks/useAuth';
import { ProtectedRouteProps } from '../types';
import { useTranslation } from '../context/TranslationContext';

const AdminProtectedRoute = ({ children, requireAdmin = false }: ProtectedRouteProps) => {
    const { user, loading, isAdmin } = useBackendAuth();
    const { t } = useTranslation();

    if (loading) {
        {
            // Show spinner with "Authenticating..." text
            return (
                <div className="flex h-screen flex-col items-center justify-center">
                    <div className="h-16 w-16 animate-spin rounded-full border-t-4 border-b-4 border-indigo-600"></div>
                    <p className="mt-6 text-2xl font-medium text-gray-800">{t('authentication.authenticating')}</p>
                </div>
            );
        }
    }

    if (!user) {
        return <Navigate to="/admin/login" replace />;
    }

    if (requireAdmin && !isAdmin()) {
        // Shop home (not "/") so we do not stack an extra redirect hop
        return <Navigate to="/home" replace />;
    }

    return children ? <>{children}</> : <Outlet />;
};

export default AdminProtectedRoute;